import { Validator } from '@vista-digital/validator';
import { defaultOccMemberPaymentCardsConfig, occMemberPaymentCardsConfigValidator } from './payment-cards';
import { defaultOccMemberSubscriptionsConfig, occMemberSubscriptionsConfigValidator } from './subscription';
export const defaultOccMemberConfig = {
    paymentCards: defaultOccMemberPaymentCardsConfig,
    subscriptions: defaultOccMemberSubscriptionsConfig
};
export const occMemberConfigValidator = Validator.object({
    paymentCards: occMemberPaymentCardsConfigValidator,
    subscriptions: occMemberSubscriptionsConfigValidator
});
